import { Record } from 'immutable';

const BoxSizeRecord = Record({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    rank: 0,
    configurationIds: {},
});

class BoxSize extends BoxSizeRecord {}

export default BoxSize;
